import React, { useMemo } from "react";
import { Layout } from "../../frontend/layout/Layout.js";
import { generateSprintDates } from "./generateSprintDates.js";
import { Column } from "../../../packages/ui/table/quick/Column.js";
import { AmbrightDate } from "./AmbrightDate.js";
import { FormattedDate } from "../../frontend/accounting/FormattedDate.js";
import { FixedTable } from "../../../packages/ui/table/quick/FixedTable.js";

/**
 * Shows the list of Ambright sprint dates.
 */
export const AmbrightPage = () => {
  const dates = useMemo(() => generateSprintDates(), []);

  const columns: Column<AmbrightDate>[] = [
    {
      span: 1,
      title: "Kuupäev",
      render: (row) => <FormattedDate date={row.date} />
    },
    {
      span: 1,
      title: "Sprint",
      render: (row) => row.sprint
    }
  ];

  return (
    <Layout title="Ambrighti sprindid">
      <h2>Ambrighti sprindid</h2>
      <FixedTable columns={columns} rows={dates} fontSize="tiny" />
    </Layout>
  );
};
